// src/components/TopFilterBar.js
import React, { useState } from 'react';
import Dropdown from './Dropdown';
import MultiDropdown from './MultiDropdown';
import YearRange from './YearRange';

const DIM_LABELS = {
  'Mineral': 'Mineral',
  'Region': 'Region',
  'Country': 'Country',
  'Form': 'Form',
  'Input': 'Input',
  'Scenario': 'Scenario',
  'Performer': 'Performer'
};

export default function TopFilterBar({ dims, yearOptions, filters, onFiltersChange }) {
  const set = (k, v) => onFiltersChange({ ...filters, [k]: v });

  const allFilters = ['Region', 'Country', 'Form', 'Input', 'Scenario', 'Performer'];

  return (
    <div className="panel topFilters">
      <div className="row row-top">
        <div className="panel-title">
          <h3>FILTERS</h3>
        </div>
        <div className="grow" />
        <div className="control yr-control">
          
          <YearRange years={yearOptions} min={filters.yearMin} max={filters.yearMax} onChange={set} />
        </div>
      </div>
      <div className="row row-bottom">
        {allFilters.map(k => (
          <div key={k} className="control">
            <label>{DIM_LABELS[k]}</label>
            {['Scenario'].includes(k)
              ? <Dropdown value={filters[k] ?? ''} onChange={v => set(k, v)} options={dims[k]} placeholder="All" className="dd-wide" />
              : <MultiDropdown values={filters[k] ?? []} onChange={v => set(k, v)} options={dims[k] ?? []} placeholder="All" className="dd-wide" />
            }
          </div>
        ))}
      </div>
    </div>
  );
}